import React, { useState } from 'react';
import { Plus, Minus, ShoppingCart } from 'lucide-react';
import { formatCurrency } from '../utils/helpers';

const ProductCard = ({ product, onAddToCart }) => {
  const [quantity, setQuantity] = useState(1);

  const handleQuantityChange = (e) => {
    const value = parseFloat(e.target.value);
    if (!isNaN(value) && value >= 0) {
      setQuantity(value);
    }
  };

  const handleIncrement = () => {
    setQuantity(prev => prev + 0.5);
  };

  const handleDecrement = () => {
    setQuantity(prev => Math.max(0.5, prev - 0.5));
  };

  const handleAddToCartClick = () => {
    if (quantity > 0) {
      onAddToCart(product, quantity);
    }
  };

  return (
    <div className="bg-white rounded-2xl shadow-lg overflow-hidden border border-gray-100 flex flex-col">
      <div className="relative h-48 w-full overflow-hidden">
        <img
          src={product.image}
          alt={product.name}
          className="w-full h-full object-cover"
        />
        <div className="absolute top-4 right-4 bg-blue-600 text-white text-sm font-bold px-3 py-1 rounded-full shadow-md">
          {formatCurrency(product.pricePerPound)}/lb
        </div>
      </div>
      <div className="p-6 flex flex-col flex-grow">
        <h3 className="text-xl font-bold text-gray-900 mb-2">{product.name}</h3>
        <p className="text-gray-600 text-sm mb-4 flex-grow">{product.description}</p>
        <div className="flex flex-col sm:flex-row items-center justify-between mb-4 gap-3">
          <span className="text-lg font-semibold text-gray-800">
            Total: {formatCurrency(product.pricePerPound * quantity)}
          </span>
          <div className="flex items-center border border-gray-200 rounded-lg">
            <button
              onClick={handleDecrement}
              className="p-2 text-gray-600 hover:bg-gray-100 rounded-l-lg"
            >
              <Minus className="w-4 h-4" />
            </button>
            <input
              type="number"
              value={quantity.toFixed(1)}
              onChange={handleQuantityChange}
              min="0.5"
              step="0.5"
              className="w-16 text-center border-x border-gray-200 py-2 text-gray-800 font-medium focus:outline-none"
            />
            <button
              onClick={handleIncrement}
              className="p-2 text-gray-600 hover:bg-gray-100 rounded-r-lg"
            >
              <Plus className="w-4 h-4" />
            </button>
          </div>
        </div>
        <button
          onClick={handleAddToCartClick}
          className="w-full bg-gradient-to-r from-blue-500 to-teal-600 text-white py-3 rounded-xl font-semibold flex items-center justify-center gap-2 shadow-lg hover:from-blue-600 hover:to-teal-700"
        >
          <ShoppingCart className="w-5 h-5" />
          Agregar al Carrito
        </button>
      </div>
    </div>
  );
};

export default ProductCard;